import { createContext } from "react";
const SeoDetailsMultipageContext = createContext({});
export default SeoDetailsMultipageContext;
